export const GET_FPS_FAMILY_MEMBER = "GET_FPS_FAMILY_MEMBER";
export const GET_SFR_FAMILY_MEMBER = "GET_SFR_FAMILY_MEMBER";
export const SFR_FAMILY_MEMBER_LOADER = "SFR_FAMILY_MEMBER_LOADER";
export const GET_FAMILY_ADULT_MEMBER_DETAILS = "GET_FAMILY_ADULT_MEMBER_DETAILS"
export const LOADER_FOR_FAMILY_ADULT_MEMBER_DETAILS = "LOADER_FOR_FAMILY_ADULT_MEMBER_DETAILS"
export const RESET_FOR_FAMILY_ADULT_MEMBER_DETAILS = "RESET_FOR_FAMILY_ADULT_MEMBER_DETAILS"
export interface IFamilyServiceState {
    eZSChildSubscribers?: IChildSubscriber[];
    seniorMemberList?: IFamilyServiceMember[];
    isLoadingSFR: boolean;
    isAdultFamilyMember: boolean;
    isAdultFamilyMemberDetailsLoaded : boolean;
}

export interface IChildSubscriber {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
}

export interface IFamilyServiceMember {
    id?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    parentUserId?: number;
    parentEzshieldId?: string;
    partner?: number;
    provisionalID?: string;
    streetNumber?: string;
    streetName?: string;
    relationshipType?: string;
    islivesInHouseHold?: boolean;
    createdTimeStamp?: any;
    updatedTimeStamp?: any;
    syncTimeStamp?: any;
    syncStatus?: string;
    isDisassociated?: boolean;
    fk_RelationshipMembersType?: number;
}

export interface GetFPSFamilyMemberAction {
    type: "GET_FPS_FAMILY_MEMBER";
    eZSChildSubscribers: IChildSubscriber[];
}
export interface GetSFRFamilyMemberAction {
    type: "GET_SFR_FAMILY_MEMBER";
    seniorMemberList: IFamilyServiceMember[];
}
export interface SFRFamilyMemberLoaderAction {
    type: "SFR_FAMILY_MEMBER_LOADER";
    isLoadingSFR: boolean;
}
export interface GetFamilyAdultMemberDetailsAction {
    type: "GET_FAMILY_ADULT_MEMBER_DETAILS";
    isAdultFamilyMember: boolean;
}
export interface LoaderForFamilyAdultMemberDetails {
    type: "LOADER_FOR_FAMILY_ADULT_MEMBER_DETAILS";
    isAdultFamilyMemberDetailsLoaded: boolean;
}
export interface ResetFamilyAdultMemberDetails {
    type: "RESET_FOR_FAMILY_ADULT_MEMBER_DETAILS";
}

export type FamilyServiceAction = GetFPSFamilyMemberAction | GetSFRFamilyMemberAction | SFRFamilyMemberLoaderAction | GetFamilyAdultMemberDetailsAction | LoaderForFamilyAdultMemberDetails | ResetFamilyAdultMemberDetails;
